import { useState } from "react";
import { TextField, Theme, createStyles, FormHelperText } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormContext, useWatch } from 'react-hook-form';
import FormErrors from '../formErrors';
import NumberFormat from "react-number-format";

const fnParseFloat = (value: string) => {
    const IsNumberic = (sVal) => {
        sVal = (sVal + "").replace(/,/g, '');
        return (!isNaN(sVal) && sVal !== "");
    }

    value = (value + "").replace(/ /g, '').replace(/,/g, '');
    if (IsNumberic(value)) {
        return parseFloat(value);
    } else {
        return null;
    }
}

const DefaultConfig = {
    integerDigits: 14,
    digits: 2,
    allowMinus: true,
    type: 'number',
    format: "",
    mask: "",
    thousandSeparator: true,
    valuetype: "text",
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, onBlur, config, name, ...other } = props;
    var xvalue = props.value;
    if (config.type === "number") {
        if (xvalue != undefined && xvalue != "") {
            var t = xvalue + "";
            var splitted = t.replace(/,/g, "").split(".");
            var c = t.search("-")
            var d = "";

            if (splitted.length > 0) {
                d = splitted[0].substring(0, config.integerDigits + (c + 1));

                if (splitted.length > 1) {
                    d = d + "." + splitted[1].substring(0, config.digits);
                    d = (+d).toFixed(config.digits);
                } else {
                    if (config.digits > 0) {
                        d = (+d).toFixed(config.digits);
                    }
                }
            }
            xvalue = d;
        }
    }

    const rangeOfLimit = (values) => {
        const { formattedValue, value, floatValue } = values;

        if(config.IsAllowZero == true)
        {
            return true;
        }
        else
        {
            if (value.charAt(0) === '0') {
                if (value.charAt(1) && value.charAt(1) != '.') {
                    return false;
                }
            }
            return formattedValue === '' || (floatValue <= 999 && floatValue > 0);
        }
        
    }

    return (
        <NumberFormat
            {...other}
            value={xvalue}
            getInputRef={inputRef}
            isAllowed={ rangeOfLimit}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: config.valuetype === "number" ? fnParseFloat(values.value) : values.value,
                        formattedValue: values.formattedValue || ""
                    }
                });
            }}
            onBlur={(values) => {
                onBlur(values)
            }}
            thousandSeparator={config.thousandSeparator}
            isNumericString
            fixedDecimalScale
            allowNegative={config.allowMinus}
            // prefix={config.prefix}
            // format={config.format}
            // maxLength={config.maxLength}
        />
    );
}

export const InputNumberFormItem = (props: InputNumberFormItemProp) => {
    const {
        name,
        label,
        integerDigits = 14,
        digits = 2,
        allowMinus = true,
        externalErrorMessage,
        required,
        disabled,
        textAlign = "right",
        defaultValues,
        type = 'number',
        format = "",
        mask,
        valuetype = 'text',
        thousandSeparator = true,
        variant,
        maxLength = '',
        hint,
        hidden,
        id,
        fullWidth,
        shrink,
        placeholder,
        autoFocus,
        startAdornment,
        IsAllowZero = true,
        sPrefix,
        endAdornment, ...other } = props;
    const {
        register,
        setValue,
        getValues,
        watch,
        control,
        formState: { errors, touchedFields, isSubmitted },
    } = useFormContext();

    const errorMessage = FormErrors.errorMessage(
        name,
        errors,
        touchedFields,
        isSubmitted,
        externalErrorMessage,
    );

    const handleChange = (event) => {
        setValue(name, (valuetype === 'number' ? fnParseFloat(event.target.value) : event.target.formattedValue), { shouldValidate: false });
        props.onChange && props.onChange(event);
    };

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                backgroundColor: disabled ? "#efefef" : "white",
                "& .Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.87)"
                },
                "& .Mui-disabled:before": {
                    borderBottom: "1px solid",
                },
            }
        }),
    );
    const classes = useStyles();

    const FieldName = useWatch({
        control,
        name: name,
    });
    const [Focus, SetFocus] = useState(false);

    return (
        <>
            <TextField
                inputRef={register(name).ref}
                {...register(name)}
                onBlur={(event) => {
                    SetFocus(false);
                    props.onBlur && props.onBlur(event);
                    setValue(name, event.target.value, { shouldValidate: true });
                }}
                variant={variant ? variant : disabled ? undefined : "outlined"}
                // variant={ disabled ? "standard" : variant ? variant : "outlined"}
                size="small"
                label={label != undefined ? label : ""}
                value={getValues(name) || ''}
                onChange={handleChange}
                name={name}
                id={id}
                onKeyDown={(e) => {
                    if (type === "number") {
                        if (digits > 0) {
                        } else {
                            if (e.key === ".") {
                                e.preventDefault();
                            }
                        }
                    }
                }}
                onKeyPress={(event) => {
                    props.onKeyPress && props.onKeyPress(event);
                }}
                onKeyUp={(event) => {
                    props.onKeyPress && props.onKeyPress(event);
                }}
                inputProps={{
                    name,
                    maxLength: maxLength ? maxLength : null,
                    style: { textAlign: textAlign },
                    config: {
                        digits: digits,
                        integerDigits: integerDigits,
                        allowMinus: allowMinus,
                        type: type,
                        format: format,
                        mask: mask,
                        thousandSeparator: thousandSeparator,
                        valuetype: valuetype,
                        IsAllowZero:IsAllowZero,
                        maxLength: maxLength,
                        prefix : sPrefix,
                        disabled: { disabled }
                    }
                }}
                onFocus={() => {
                    SetFocus(true);
                }}
                InputLabelProps={{
                    shrink: FieldName || Focus ? true : false,
                }}
                InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: startAdornment != undefined ? startAdornment : null,
                    endAdornment: endAdornment != undefined ? endAdornment : null,
                }}
                fullWidth={fullWidth != undefined ? fullWidth : true}
                autoComplete={"off"}
                error={Boolean(errorMessage)}
                required={required}
                disabled={disabled}
                classes={classes}
                hidden={hidden}
                placeholder={placeholder || undefined}
                sx={{
                    "label.MuiInputLabel-shrink": {
                        top: "0px",
                    },
                    ".MuiInputLabel-outlined": {
                        top: "0px",
                    },
                    ".MuiInputLabel-asterisk": {
                        color: "red"
                    }
                }}
            />
            {errors && errors[name] ? (
                <FormHelperText sx={{ color: "red" }}>
                    {errors[name].message}
                </FormHelperText>
            ) : null}
        </>
    );
};
interface InputNumberFormItemProp {
    name: string,
    required: boolean,
    label?: string,
    hint?: string,
    disabled?: boolean,
    externalErrorMessage?: any,
    onChange?: any,
    onBlur?: any,
    digits?: number,
    integerDigits?: number,
    allowMinus?: boolean,
    textAlign?: 'inherit' | 'left' | 'center' | 'right' | 'justify',
    defaultValues?: string,
    type?: "number",
    format?: "#### ##" | "## ##" | "(###) ###-####" | any,
    mask?: "_" | any,
    valuetype?: "number" | "text",
    thousandSeparator?: boolean,
    variant?: "filled" | "standard" | "outlined" | undefined,
    maxLength?: number,
    hidden?: boolean,
    id?: string,
    fullWidth?: boolean,
    startAdornment?: any,
    endAdornment?: any,
    shrink?: boolean,
    placeholder?: string,
    autoFocus?: boolean,
    IsAllowZero?: boolean,
    onKeyDown?: any,
    onKeyPress?: any,
    onKeyUp?: any,
    sPrefix?: any,
}
export default InputNumberFormItem;